
import { Component, Vue, Prop } from "vue-property-decorator";

import moment from "moment";
moment.locale("es");
@Component({
  watch: {},
  components: {
    Paginator: () => import("@/components/Paginator.vue"),
    SortColumn: () => import("@/components/SortColumn.vue")
  },
  computed: {},
  filters: {
    date(value) {
      return value ? moment(value, "YYYY-MM-DD").format("DD/MM/YYYY") : "";
    }
  }
})
export default class Summary extends Vue {
  @Prop(Array) readonly requests;
  @Prop(Number) readonly modifyType;
  @Prop(Function) readonly handleModifyType;
  @Prop(Number) readonly limit: number;
  @Prop(Function) readonly handleLimit;
  @Prop(Number) readonly totalRows: number;
  @Prop(Object) readonly currentSort: any;
  @Prop(Function) readonly loadRequests;
  statuses: any = [];
  async loadStatuses() {
    const response: any = await (this.$root as any)._get("requests/status");
    this.statuses = response;
  }
  statusClass(status) {
    if (status === 0 || status === 1) return "active";
    if (status === 5) return "pending";
    return "inactive";
  }
  async onPageChange(page: number, limit: number) {
    await this.handleLimit(limit);
    await this.loadRequests(page, this.currentSort);
  }
  async mounted() {
    await this.loadStatuses();
  }
}
